import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalEditPersonalInfo } from '../../../../redux/actions/partials/modals/modalEditPersonalInfo';
import { handleChangeProfileData } from "../../../../redux/actions/pages/user/user";
import { USERS_EDIT_PERSONAL_INFO_POST } from '../../../../apis';
import useOutsideClick from './hooks/useOutsideClick'; 
import apiRequest from '../../../../utils/apiRequest';


const ModalEditPersonalInfo = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, fname, lname, nationalCode, birthYear, birthMonth, birthDay, 
		fnameErr, lnameErr, nationalCodeErr,
		showYearOptions, showMonthOptions, showDayOptions, } = useSelector(state => state.modalEditPersonalInfo);
	const { token, profile } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);


	useEffect(() => {
	    if(isActive) {
	    	dispatch(handleChangeDataModalEditPersonalInfo('fname', profile.fname));
	    	dispatch(handleChangeDataModalEditPersonalInfo('lname', profile.lname));
	    	dispatch(handleChangeDataModalEditPersonalInfo('nationalCode', profile.national_code));
	    	const birthDate = profile.birth_date != null ? profile.birth_date.split("/") : [];
	    	if(birthDate.length === 3) {
	    		dispatch(handleChangeDataModalEditPersonalInfo('birthYear', birthDate[0]));
	    		dispatch(handleChangeDataModalEditPersonalInfo('birthMonth', birthDate[1]));
	    		dispatch(handleChangeDataModalEditPersonalInfo('birthDay', birthDate[2]));
	    	}
	    }
	}, [isActive]);



	const handleClose = () => {
		dispatch(handleChangeDataModalEditPersonalInfo('birthYear', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('birthMonth', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('birthDay', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('nationalCode', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('fname', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('lname', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('fnameErr', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('lnameErr', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('nationalCodeErr', ''));

		dispatch(handleChangeDataModalEditPersonalInfo('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalEditPersonalInfo('isOpen', false));
        }, 250);
    };    


    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalEditPersonalInfo]);

  	

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalEditPersonalInfo(name, value));
    };

    const handleToggleShowDayOptions = () => {
    	dispatch(handleChangeDataModalEditPersonalInfo('showDayOptions', !showDayOptions));
    }
	
	const handleToggleShowMonthOptions = () => {
    	dispatch(handleChangeDataModalEditPersonalInfo('showMonthOptions', !showMonthOptions));
    }

    const handleToggleShowYearOptions = () => {
    	dispatch(handleChangeDataModalEditPersonalInfo('showYearOptions', !showYearOptions));
    }

    const handleSelectDay = (day) => {
    	dispatch(handleChangeDataModalEditPersonalInfo('birthDay', day));
    	dispatch(handleChangeDataModalEditPersonalInfo('showDayOptions', false));
    };

    const persianMonths = [
  		'فروردین', 'اردیبهشت', 'خرداد', 'تیر',
  		'مرداد', 'شهریور', 'مهر', 'آبان',
  		'آذر', 'دی', 'بهمن', 'اسفند'
	];

	const handleSelectMonth = (monthNum) => {
		dispatch(handleChangeDataModalEditPersonalInfo('birthMonth', monthNum));
    	dispatch(handleChangeDataModalEditPersonalInfo('showMonthOptions', false));
	};

	const years = [
  		"1399", "1398", "1397", "1396", "1395", "1394", "1393", "1392", "1391", "1390",
  		"1389", "1388", "1387", "1386", "1385", "1384", "1383", "1382", "1381", "1380",
  		"1379", "1378", "1377", "1376", "1375", "1374", "1373", "1372", "1371", "1370",
  		"1369", "1368", "1367", "1366", "1365", "1364", "1363", "1362", "1361", "1360",
  		"1359", "1358", "1357", "1356", "1355", "1354", "1353", "1352", "1351", "1350",
  		"1349", "1348", "1347", "1346", "1345", "1344", "1343", "1342", "1341", "1340",
  		"1339", "1338", "1337", "1336", "1335", "1334", "1333", "1332", "1331", "1330",
  		"1329", "1328", "1327", "1326", "1325", "1324", "1323", "1322", "1321", "1320",
  		"1319", "1318", "1317", "1316", "1315", "1314", "1313", "1312", "1311", "1310",
  		"1309", "1308", "1307", "1306", "1305", "1304", "1303", "1302", "1301", "1300",
	];

	const handleSelectYear = (year) => {
    	dispatch(handleChangeDataModalEditPersonalInfo('birthYear', year));
    	dispatch(handleChangeDataModalEditPersonalInfo('showYearOptions', false));
    };

    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };

 	const convertPersianArabicNumbersToEnglish = (str) => {
 		let persianArabicNumbers = {
	        '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
	        '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
	        '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
	        '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
	    };

	    return str.replace(/[۰-۹٠-٩]/g, (char) => persianArabicNumbers[char] || char);
 	};

    const handleSubmitForm = (event) => {
    	event.preventDefault();

    	if(! isBackdropLoading) {
    		let error = false;

	    	if(fname.length === 0)
	    		dispatch(handleChangeDataModalEditPersonalInfo('fnameErr', 'لطفا این قسمت را خالی نگذارید!'));
	    	else if(fname.length < 2 && fname.length > 0)
	    		dispatch(handleChangeDataModalEditPersonalInfo('fnameErr', 'نام باید حداقل 2 کارکاتر باشد!'));

	    	if(lname.length === 0)
	    		dispatch(handleChangeDataModalEditPersonalInfo('lnameErr', 'لطفا این قسمت را خالی نگذارید!'));
	    	else if(lname.length < 2 && lname.length > 0)
	    		dispatch(handleChangeDataModalEditPersonalInfo('lnameErr', 'نام خانوادگی  باید حداقل 2 کارکاتر باشد!'));

	    	if(nationalCode.length === 0)
	    		dispatch(handleChangeDataModalEditPersonalInfo('nationalCodeErr', 'لطفا این قسمت را خالی نگذارید!'));
	    	else if(nationalCode.length !== 11 && lname.length > 0)
	    		dispatch(handleChangeDataModalEditPersonalInfo('nationalCodeErr', 'کدملی باید 10 رقم باشد!'));

	    	if(! error) {
	    		dispatch(handleChangeDataModalEditPersonalInfo('fnameErr', ''));
	    		dispatch(handleChangeDataModalEditPersonalInfo('lnameErr', ''));
	    		dispatch(handleChangeDataModalEditPersonalInfo('nationalCodeErr', ''));


	    		apiRequest({
				    dispatch,
				    endpoint: USERS_EDIT_PERSONAL_INFO_POST,
				    method: 'post',
				    data: { fname, lname, national_code: convertPersianArabicNumbersToEnglish(nationalCode), birth_day: birthDay, birth_month: birthMonth, birth_year: birthYear },
				    token: token,
				    successMessage: 'اطلاعات شما با موفقیت ویرایش شد',
				    onSuccess: (res) => {
				      	dispatch(handleChangeProfileData(res.info));
	                    handleClose();
				    },
			  	});

	    	}
    	}
    };

    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '460px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '59px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width="420" height="58.59375">
						<div className="flex items-center border-complete-b-200">
							<div className="break-words py-3 grow">
								<div className="flex items-center grow">
									<p className="grow text-h5 text-neutral-900">
										<span className="relative">ثبت اطلاعات شناسایی
										</span>
									</p>
								</div>
							</div>
							<div className="grow text-h5">
							</div>
							<div className="flex cursor-pointer" onClick={handleClose}>
								<svg data-test-id="close-modal-icon-button" style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
									<use xlinkHref="#close"></use>
								</svg>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q py-4 px-5">
							<div className="pt-4">
								<form className="w-full pb-20 lg:pb-0 flex flex-wrap">
									<p className="text-body-1 text-neutral-800 lg:col-span-2 mb-2">لطفا اطلاعات شناسایی خود را وارد کنید. نام و نام خانوادگی شما باید با اطلاعاتی که وارد می‌کنید همخوانی داشته باشند.
									</p>
									<label className="FormComponentFrame_FormComponentFrame__PIUpy FormComponentFrame_FormComponentFrame--normal__TQSOm w-[48%]">
										<div className="flex justify-between items-center">
											<p className="mb-2 text-neutral-700 text-body-1">نام
												<span className="text-primary-500">*
												</span>
											</p>
										</div>
										<div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 Input_InputWrapper__d_4kf">
											<div className="grow text-body-3">
												<input className="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium" type="text" name="fname" autoComplete="off" value={fname} onChange={handleChangeInputs} />
											</div>
											<div className="flex">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-success)'}}>
													<use xlinkHref="#active"></use>
												</svg>
											</div>
										</div>
										<p className="text-body-2 text-hint-text-error">{fnameErr}</p>
									</label>
									<label className="FormComponentFrame_FormComponentFrame__PIUpy FormComponentFrame_FormComponentFrame--normal__TQSOm w-[48%] mr-auto">
										<div className="flex justify-between items-center">
											<p className="mb-2 text-neutral-700 text-body-1">نام‌خانوادگی
												<span className="text-primary-500">*
												</span>
											</p>
										</div>
										<div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 Input_InputWrapper__d_4kf">
											<div className="grow text-body-3">
												<input className="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium" type="text" name="lname" autoComplete="off" value={lname} onChange={handleChangeInputs} />
											</div>
											<div className="flex">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-success)'}}>
													<use xlinkHref="#active"></use>
												</svg>
											</div>
										</div>
										<p className="text-body-2 text-hint-text-error">{lnameErr}</p>
									</label>
									{/*<label className="flex gap-5 items-center max-w-35 mt-2">
										<label className="flex items-center cursor-pointer styles_Checkbox__checkboxContainer__7joRB py-1">
											<input className="invisible absolute" type="checkbox" name="userIsForeigner" />
											<span className="inline-flex justify-center items-center cursor-pointer rounded-small shrink-0 styles_Checkbox__checkbox__z1B5a styles_Checkbox__checkbox--secondary__FspFz">
												<div className="flex styles_Checkbox__icon__AaKB1">
													<svg style={{width: '10px', height: '10px', fill: 'var(--color-icon-white)'}}>
														<use xlinkHref="#check"></use>
													</svg>
												</div>
											</span>
										</label>
										<p className="text-body1-strong text-neutral-700">اتباع خارجی هستم و کد ملی ندارم
										</p>
									</label>*/}
									<label className="FormComponentFrame_FormComponentFrame__PIUpy w-full FormComponentFrame_FormComponentFrame--normal__TQSOm mt-2">
										<div className="flex justify-between items-center">
											<p className="mb-2 text-neutral-700 text-body-1">کد ملی
												<span className="text-primary-500">*</span>
											</p>
										</div>
										<div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 Input_InputWrapper__d_4kf">
											<div className="grow text-body-3">
												<input className="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium" type="text" name="nationalCode" autoComplete="off" value={toPersianDigits(nationalCode ?? "")} onChange={handleChangeInputs} />
											</div>
										</div>
										<p className="text-body-2 text-hint-text-error">{nationalCodeErr}</p>
									</label>
									<p className="w-full text-body-1 text-neutral-700 mb-2 mt-4">تاریخ تولد
									</p>
									<div className="max-w-[30%]">
										<div className="select-none text-body-1 mb-2 text-neutral-700">روز
										</div>
										<div className="relative">
											<input type="hidden" name="userBirthDay" value="" />
											<input type="text" readonly="" placeholder="روز" className="font-iran-yekan h-12 w-full px-3 py-2 outline-none md:text bg-neutral-100 lg:bg-neutral-000 cursor-pointer rounded border-complete styles_DropDown__input--bordered__jYaLg lg:border-complete-200" value={toPersianDigits(birthDay)} onClick={handleToggleShowDayOptions} />
											<div className="flex cursor-pointer absolute top-0 left-0 mt-3 ml-3 select-none cursor-pointer transform text-neutral-800">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
													<use xlinkHref="#dropdown"></use>
												</svg>
											</div>
											{ showDayOptions ?
												<ul className="absolute z-1 w-full overflow-hidden overflow-y-auto rounded mt-1 bg-neutral-000 border-complete-200 user-select-none styles_DropDown__list__oBOIc">
													{
														[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31].map((val) => (
															<li key={val} data-value={val} onClick={(e) => handleSelectDay(e.currentTarget.getAttribute('data-value'))} className="px-3 w-full select-none flex items-center text-body-1 cursor-pointer hover:bg-neutral-100 text-neutral-800">{toPersianDigits(val)}</li>
														))
													}
												</ul>
											:''}
										</div>
									</div>
									<div className="mr-auto max-w-[30%]">
										<div className="select-none text-body-1 mb-2 text-neutral-700">ماه
										</div>
										<div className="relative">
											<input type="hidden" name="userBirthMonth" value="" />
											<input type="text" readonly="" placeholder="ماه" className="font-iran-yekan h-12 w-full px-3 py-2 outline-none md:text bg-neutral-100 lg:bg-neutral-000 cursor-pointer rounded border-complete styles_DropDown__input--bordered__jYaLg lg:border-complete-200" value={persianMonths[birthMonth - 1]} onClick={handleToggleShowMonthOptions} />
											<div className="flex cursor-pointer absolute top-0 left-0 mt-3 ml-3 select-none cursor-pointer transform text-neutral-800">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
													<use xlinkHref="#dropdown"></use>
												</svg>
											</div>
											{ showMonthOptions ?
												<ul className="absolute z-1 w-full overflow-hidden overflow-y-auto rounded mt-1 bg-neutral-000 border-complete-200 user-select-none styles_DropDown__list__oBOIc">
													{
														persianMonths.map((month, index) => (
															<li key={index} data-value={index + 1} onClick={(e) => handleSelectMonth(e.currentTarget.getAttribute('data-value'))} className="px-3 w-full select-none flex items-center text-body-1 cursor-pointer hover:bg-neutral-100 text-neutral-800">{month}</li>
														))
													}
												</ul>
											:''}
										</div>
									</div>
									<div className="mr-auto max-w-[30%]">
										<div className="select-none text-body-1 mb-2 text-neutral-700">سال
										</div>
										<div className="relative">
											<input type="hidden" name="userBirthYear" value="" />
											<input type="text" readonly="" placeholder="سال" className="font-iran-yekan h-12 w-full px-3 py-2 outline-none md:text bg-neutral-100 lg:bg-neutral-000 cursor-pointer rounded border-complete styles_DropDown__input--bordered__jYaLg lg:border-complete-200" value={toPersianDigits(birthYear)} onClick={handleToggleShowYearOptions} />
											<div className="flex cursor-pointer absolute top-0 left-0 mt-3 ml-3 select-none cursor-pointer transform text-neutral-800">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
													<use xlinkHref="#dropdown"></use>
												</svg>
											</div>
											{ showYearOptions ?
												<ul className="absolute z-1 w-full overflow-hidden overflow-y-auto rounded mt-1 bg-neutral-000 border-complete-200 user-select-none styles_DropDown__list__oBOIc">
													{
														years.map((year, index) => (
															<li key={index} data-value={year} onClick={(e) => handleSelectYear(e.currentTarget.getAttribute('data-value'))} className="px-3 w-full select-none flex items-center text-body-1 cursor-pointer hover:bg-neutral-100 text-neutral-800">{toPersianDigits(year)}</li>		
														))
													}
												</ul>
											:''}
										</div>
									</div>
									<div className="bg-neutral-000 w-full px-5 py-3 lg:p-0 flex flex-col lg:flex-row justify-center lg:justify-end items-center mt-4 lg:mt-20 fixed lg:relative bottom-0 left-0 shadow-1-top lg:!shadow-none lg:col-span-2">
										<button onClick={handleSubmitForm} className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium w-full lg:w-unset">
											<div className="flex items-center justify-center relative grow">بررسی اطلاعات
											</div>
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalEditPersonalInfo;
